export default __webpack_public_path__ + "static/media/medical-team-doctor-s-office (1).67ec7c45.jpg";